import styled from 'styled-components'

export const ProgressContainer = styled.div`
  padding: 0 16px 16px 16px;
`
